import { createSlice } from '@reduxjs/toolkit';
import { fetchAllUsers, fetchCustomerInfo, getAdminProfile } from './actions';

const initialState = {
  data: [],
  profile: {},
  singleUser: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerInfo.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.singleUser = {};
      })
      .addCase(fetchCustomerInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(fetchCustomerInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.singleUser = action.payload;
      })
      .addCase(fetchAllUsers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = [];
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.data = action.payload;
      })
      .addCase(getAdminProfile.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.profile = {};
      })
      .addCase(getAdminProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAdminProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.profile = action.payload;
      });
  },
});

export const getCustomerData = (state) => state.user.singleUser;

export default user.reducer;
